import { render, staticRenderFns } from "./SocialPostEditorialCreate.vue?vue&type=template&id=1278d126&scoped=true&"
import script from "./SocialPostEditorialCreate.vue?vue&type=script&lang=js&"
export * from "./SocialPostEditorialCreate.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostEditorialCreate.vue?vue&type=style&index=0&id=1278d126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278d126",
  null
  
)

export default component.exports